export const animalGenders = {
    male: 'male',
    female: 'female'
};

export const animalTypes = {
    adult: 'adult',
    child: 'child',
    group: 'group'
};

export const animalByTypes = {
    single: ['bovine', 'ovine'],
    group: ['porcine']
};

export const animalSpecies = {
    bovine: 'bovine',
    porcine: 'porcine'
};
export const animalStates = {
    pregnancy: 'pregnancy',
    breeding: 'breeding',
    maintenance: 'maintenance',
    growing: 'growing',
    fattening: 'fattening',
    ready: 'ready',
    sold: 'sold'
};
